import React from "react";

import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import LinkOffIcon from "@mui/icons-material/LinkOff";
import Share from "@mui/icons-material/Share";
import VideocamIcon from "@mui/icons-material/Videocam";
import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from "react-i18next";

import { useReadOnly } from "../../contexts/ReadOnlyContext";
import { ICircularButton } from "./interface";
import { CircleDiv, CircleDivDisabled } from "./styles";

export const CircularButton: React.FC<ICircularButton> = ({
  id,
  icon,
  backgroundColor,
  border,
  colorIcon,
  disabled = false,
  onClick,
  copyTooltip,
  highlight,
}) => {
  const { t } = useTranslation();
  const readOnly = useReadOnly();
  const isDisabled = disabled || readOnly;
  

  function getIcon(disabledIcon?: boolean) {
    switch (icon) {
      case "add":
        return disabledIcon ? (
          <AddIcon data-cy={id} style={{ height: 24, width: 24 }} />
        ) : (
          <Tooltip title={t("common.add")}>
            <AddIcon data-cy={id} style={{ height: 24, width: 24 }} />
          </Tooltip>
        );
      case "edit":
        return disabledIcon ? (
          <EditIcon data-cy={id} style={{ height: 16, width: 16 }} />
        ) : (
          <Tooltip title={t("common.edit")}>
            <EditIcon data-cy={id} style={{ height: 16, width: 16 }} />
          </Tooltip>
        );
      case "delete":
        return disabledIcon ? (
          <DeleteIcon data-cy={id} style={{ height: 16, width: 16 }} />
        ) : (
          <Tooltip title={t("common.delete")}>
            <DeleteIcon data-cy={id} style={{ height: 16, width: 16 }} />
          </Tooltip>
        );
      case "copy":
        return disabledIcon ? (
          <Share data-cy={id} style={{ height: 16, width: 16 }} />
        ) : (
          <Tooltip title={copyTooltip || t("common.copyLink")}>
            <Share data-cy={id} style={{ height: 16, width: 16 }} />
          </Tooltip>
        );
      case "desfix":
        return disabledIcon ? (
          <LinkOffIcon data-cy={id} style={{ height: 16, width: 16 }} />
        ) : (
          <Tooltip title={t("common.unlink")}>
            <LinkOffIcon data-cy={id} style={{ height: 16, width: 16 }} />
          </Tooltip>
        );
      case "record":
        return disabledIcon ? (
          <VideocamIcon
            data-cy={id}
            style={{ height: 22, width: highlight ? 22 : 16 }}
          />
        ) : (
          <Tooltip title={t("common.access")}>
            <VideocamIcon
              data-cy={id}
              style={{ height: 22, width: highlight ? 22 : 16 }}
            />
          </Tooltip>
        );
      case "Mconfcopy":
        return disabledIcon ? (
          <Share data-cy={id} style={{ height: 16, width: 16 }} />
        ) : (
          <Tooltip title={copyTooltip || ""}>
            <Share data-cy={id} style={{ height: 16, width: 16 }} />
          </Tooltip>
        );
      default:
        return disabledIcon ? (
          <AddIcon
            data-cy={id}
            style={{ height: 24, width: 24 }}
            aria-label={t("common.add")}
          />
        ) : (
          <Tooltip title={t("common.add")}>
            <AddIcon
              data-cy={id}
              style={{ height: 24, width: 24 }}
              aria-label={t("common.add")}
            />
          </Tooltip>
        );
    }
  }

  return (
    <>
      {!isDisabled ? (
        <CircleDiv
          id={id}
          data-cy={id}
          data-testid={id}
          onClick={onClick}
          backgroundColor={backgroundColor}
          border={border}
          colorIcon={colorIcon}
          role="button"
          aria-disabled={false}
          widthHeight={highlight ? 26 : 20}
        >
          {getIcon(false)}
        </CircleDiv>
      ) : (
        <CircleDivDisabled
          data-testid={`${id}-disabled`}
          aria-disabled={true}
          tabIndex={-1}
          widthHeight={highlight ? 26 : 20}
        >
          {getIcon(true)}
        </CircleDivDisabled>
      )}
    </>
  );
};

export default CircularButton;
